<!--
	描述：通用的键值对录入方式弹窗
-->
<template>
	<dialogBody class="addDialogBody" @confirm="confirm" @cancel="cancel" :showCance="showCance" ref="body">
		<template slot="title">
			{{title}}
		</template>
		<p class="message">{{nowMsg}}</p>
	</dialogBody>
</template>

<script>
	import dialogBody from './dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: [],
		data() {
			return {
				title: '',
				nowMsg: '',
				callback: undefined,
				cancelCallBack: undefined,
				showCance: true
			}
		},
		computed: {},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if (this.callback != undefined) {
					this.callback()
				}
				this.close()
			},
			cancel() {
				if (this.cancelCallBack != undefined) {
					this.cancelCallBack()
				}
				this.close()
			},
			open(title, nowMsg, callback, cancelcallback, showCance) {
				if (this.title == '异地登录' && this.$refs.body.isShow) {
					//打开状态下不会被别的弹窗掩盖
					return
				}
				this.title = title
				this.nowMsg = nowMsg
				this.callback = callback
				this.cancelCallBack = cancelcallback
				this.$refs.body.open()
				if (showCance != undefined) {
					this.showCance = showCance
				}
			},
			close() {
				this.$refs.body.hide()
			},
		}
	}
</script>
<style scoped>
	.addDialogBody {
		z-index: 200;
		display: flex;
		align-items: center;
		height: .4rem;
		justify-content: center;
	}

	.addDialogBody>span {}

	.addDialogBody>input {
		border: .01rem solid #A9A9A9;
		border-radius: .05rem;
		margin-left: .2rem;
		padding: .02rem .05rem;
		line-height: .25rem;
		width: 2rem;
	}
</style>
